module.exports = __webpack_public_path__ + "assets/sepan.1d67b93a.svg";